import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_BUS_MAINTENANCE_STAY,
  CLEAR_BUSSES_MAINTENANCE_STAY,
  FLAG_BUS_MAINTENANCE_STAY,
  FLAG_GETTING_BUSSES_MAINTENANCE_STAY,
  GET_BUS_MAINTENANCE_STAY,
  GET_BUSSES_MAINTENANCE_STAY,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_BUSSES_MAINTENANCE_STAY:
      return state.setIn(['all', 'loading'], payload);
    case GET_BUSSES_MAINTENANCE_STAY:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_BUSSES_MAINTENANCE_STAY:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_BUS_MAINTENANCE_STAY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_BUS_MAINTENANCE_STAY:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_BUS_MAINTENANCE_STAY:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
